module.exports = __webpack_public_path__ + "static/media/voucher-icon.f8d25451.svg";